module.exports = __webpack_public_path__ + "static/media/sidebar_upload_blue.460b08f2.svg";